import styles from './AssetsSelectedPopover.module.scss';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { Popup } from 'react-leaflet';
import { useNavigate } from 'react-router-dom';
import { ModelName } from '@casops/store/api';
import { GhostIconButton } from '@dmc/ui';

interface AssetsSelectedPopoverProps {
  id?: number;
  label: string;
}

export function AssetsSelectedPopover({ id, label }: AssetsSelectedPopoverProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onViewDetails = useCallback(() => {
    navigate(`/assets/asset/${id}/details`);
  }, [navigate, id]);

  return (
    <Popup key={id} className={styles.popupContainer} autoPan={false}>
      <div className={styles.popupTitle}>{label}</div>
      <div className={styles.popupDivider}></div>
      <div className={styles.popupActions}>
        <GhostIconButton icon="open-icon" onClick={onViewDetails}>
          {t('Model.Collection.Title', { modelName: ModelName.AssetDetail })}
        </GhostIconButton>
      </div>
    </Popup>
  );
}

export default AssetsSelectedPopover;
